import { setDefaultOptions } from "date-fns"
import i18n from "@/locales/i18n"
import { getDateLocale } from "./dateLocales"

const applyLocale = (language: string | undefined) => {
  setDefaultOptions({
    locale: getDateLocale(language),
    weekStartsOn: 1,
    firstWeekContainsDate: 4,
  })
}

applyLocale(i18n.language)
i18n.on("languageChanged", applyLocale)
